// PieChartComponent.js
import React, { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import apiClient from '../../api';
import LineChartComponent from './FeedbackLineChart';

// Register the necessary chart components
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChartComponent = ({ data }) => {
  const [pieData, setPieData] = useState([]);

  useEffect(() => {
    const fetchPieData = async () => {
      try {
        const newPieData = [];
        for (let i = 0; i < data.length; i++) {
          const { api: endpoint, title,ApiResponseField } = data[i];
          const response = await apiClient.get(endpoint);
          const result = response.data;

          // Extract data for labels and counts based on the provided API structure
          const labels = result.map(item => item[ApiResponseField]); // Dynamic field (e.g., company)
          const counts = result.map(item => item.count); // Dynamic count value

          const chartData = {
            labels: labels, // Labels for the pie chart (companies)
            datasets: [
              {
                label: title,
                data: counts, // Data for the pie chart (counts)
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#FF9F40'],
                hoverBackgroundColor: ['#FF4C62', '#2A8BB9', '#FFB13C', '#4BC0B0', '#FF9F20'],
              },
            ],
          };
          newPieData.push({ title, data: chartData });
        }
        setPieData(newPieData);
      } catch (error) {
        console.error("Error fetching pie chart data:", error);
      }
    };

    fetchPieData();
  }, [data]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
      {pieData.map((chart, index) => (
        <div className="bg-white shadow rounded-lg p-6 flex flex-col justify-center items-center" key={index}>
          <h2 className="text-xl font-semibold">{chart.title}</h2>
          <Pie data={chart.data} />
        </div>
      ))}
      <div className="bg-white shadow rounded-lg p-6 col-span-3 sm:col-span-2">
        <LineChartComponent api="/feedback/aggregate" />
      </div>
    </div>
  );
};

export default PieChartComponent;
